import { Szas } from 'jobs.types';
import { useTranslation } from 'react-i18next';

const useGetPensumString = (szas: Szas) => {
  const { t } = useTranslation('jobs');

  if (!szas) return '';
  if (!szas['sza_pensum.min'] && !szas['sza_pensum.max']) {
    return szas.sza_pensum;
  }
  if (szas['sza_pensum.min'] === szas['sza_pensum.max']) {
    return `${szas['sza_pensum.min']}%`;
  }

  if (szas['sza_pensum.min'] && !szas['sza_pensum.max']) {
    return t('filters_pensum_min', { min: szas['sza_pensum.min'] });
  }

  if (szas['sza_pensum.max'] && !szas['sza_pensum.min']) {
    return t('filters_pensum_max', { max: szas['sza_pensum.max'] });
  }

  return `${szas['sza_pensum.min']}-${szas['sza_pensum.max']}%`;
};

export default useGetPensumString;
